export const TRAFFIC_LIGHT_THRESHOLDS = {
  greenMin: 50,
  yellowMin: 10,
} as const;

export type TrafficLightLevel = 'green' | 'yellow' | 'red';

export function resolveTrafficLightLevelByPercentage(
  percentage: number
): TrafficLightLevel {
  if (percentage >= TRAFFIC_LIGHT_THRESHOLDS.greenMin) {
    return 'green';
  }

  if (percentage >= TRAFFIC_LIGHT_THRESHOLDS.yellowMin) {
    return 'yellow';
  }

  return 'red';
}